import React from "react";
import { Skeleton } from "@material-ui/lab";
import AudioIcon from "../AudioIcon";
import { DataGridCustomPagination, dateFormatter } from "../helpers";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { withStyles } from "@mui/styles";
import { Box, Button } from "@mui/material";
import dayjs from "dayjs";

const StyledDataGrid = withStyles({
  root: {
    "& .MuiDataGrid-cell": {
      padding: "0px",
      boxSizing: "border-box",
    },
    "& .MuiDataGrid-renderingZone": {
      transform: "none !important",
    },
    "& .MuiDataGrid-viewport": {
      position: "static",
      overflow: "visible",
    },
  },
})(DataGrid);

const DictationsList = ({
  practice_id,
  records,
  currentPlaying,
  setCurrentPlaying,
  status,
  assignToMe,
  loading,
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      field: "scribe_id",
      headerName: " ",
      minWidth: 125,
      flex: 1,
      sortable: false,
      align: "center",
      filterable: false,
      renderCell: (e) => {
        return e.row.scribe_id === null &&
          status === "Total Cases Available" ? (
          <button
            className="list-view-btn"
            onClick={() => assignToMe(e.row.id)}
          >
            Assign to me
          </button>
        ) : (
          <div className="list-assn-div">
            {status === "Total Cases Available" && "ASSIGNED"}
            <Link
              to="/scribe-notes-details/data"
              state={e.row}
              className="list-view-btn"
              // target="_blank"
            >
              View
            </Link>
          </div>
        );
      },
    },
    {
      field: "dos",
      headerName: "Date of service",
      minWidth: 120,
      flex: 1,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return dayjs(value).format("MM/DD/YYYY");
      },
      valueGetter: dateFormatter,
    },
    {
      field: "first_name",
      headerName: "Patient Name",
      minWidth: 60,
      flex: 1,
      renderCell: (e) => {
        return (
          <Button
            variant="text"
            onClick={() =>
              navigate(
                `/patients-details/${e.row.first_name}-${e.row.last_name}`,
                { state: e.row }
              )
            }
            className="ml-10"
          >
            {e.row.first_name} {e.row.last_name}
          </Button>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      minWidth: 100,
      flex: 1,
      renderCell: (e) => {
        return <div className="ml-10">{e.row.title}</div>;
      },
    },
    {
      field: "audio_duration",
      headerName: "Recording",
      minWidth: 140,
      flex: 1,
      filterable: false,
      renderCell: (e) => {
        return (
          e.value && (
            <div className="list-duration ml-10">
              {e.value}
              <Box ml={2}>
                <AudioIcon
                  showPlayer={true}
                  id={e.row.id}
                  currentPlaying={currentPlaying}
                  setCurrentPlaying={setCurrentPlaying}
                  practice_id={practice_id}
                  npi={e.row.npi}
                  ext={e.row.file_extension}
                />
              </Box>
            </div>
          )
        );
      },
    },
    {
      field: "provider_first_name",
      headerName: "Doctor’s / Practice Name",
      minWidth: 150,
      flex: 1,
      renderCell: (e) => {
        return <div className="ml-10">{e.row.provider_name}</div>;
      },
    },
    {
      field: "updated_by",
      headerName: "Last updated By",
      minWidth: 200,
      flex: 1,
      renderCell: (e) => <div className="ml-10">{e.value}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
      renderCell: (e) => <div className="ml-10">{e.value}</div>,
    },
    {
      field: "updated_date",
      headerName: "Last updated",
      minWidth: 125,
      flex: 1,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return dayjs(value).format("MM/DD/YYYY");
      },
      valueGetter: dateFormatter,
    },
    {
      field: "id",
      headerName: "ID",
      minWidth: 90,
      flex: 1,
      align: "center",
      renderCell: (e) => <div className="ml-10">{e.value}</div>,
    },
  ];

  if (records === null) {
    return (
      <div>
        <Skeleton variant="text" height={50} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
      </div>
    );
  }
  return (
    <div className="list-datagrid">
      <StyledDataGrid
        loading={loading || false}
        rows={records}
        columns={columns}
        autoHeight="true"
        disableRowSelectionOnClick
        pagination
        pageSize={10}
        slots={{
          pagination: DataGridCustomPagination,
        }}
        hideFooterPagination={!status}
        hideFooter={!status}
      />
    </div>
  );
};

export default DictationsList;
